import { Component, OnInit, Inject, Input } from '@angular/core';
import { MdInputModule, MdCheckboxModule, MdDialog, MdDialogRef, MD_DIALOG_DATA } from '@angular/material';
import { Utility } from '../../../common/utility';

import { DialogService } from '../../../shared/services/dialog.service';
import { BaseService } from '../../../shared/services/base.service';
import { ValidationService } from '../../../shared/services/validation.service';
import { AppConstants } from '../../../shared/constants/constants';
import { AppMessages } from '../../../shared/constants/messages';

import { DialogComponent } from '../../../components/dialog/dialog.component';
import { FormLabelComponent } from '../../../components/form/label/label.component';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';

import { FormMessageComponent } from '../../../components/form/message/message.component';

import { PayMethodModel, CurrencyModel } from '../../../models/consultation/cash-sale.model';
import { FormControl } from '@angular/forms/src/model';
import { Router } from '@angular/router';
import { ConsultationStepInfo } from '../../../models/consultation/consultation.model';
import { EmailInvoicePopupComponent } from './email-invoice-popup.component';
import { SharedService } from '../../../shared/services/share.services';
@Component({
    selector: 'confirm-pay-method-popup',
    templateUrl: 'confirm-pay-method-popup.component.html',
    styles: [
        `button {
            margin: 5px 0;
        }`
    ],
    providers: [SharedService],
})
export class ConfirmPayMethodPopupComponent implements OnInit {
    public isAssignSuccess = false;
    createGroupForm: FormGroup;
    private reportTokenId: string;
    constructor(
        public utility: Utility,
        public baseService: BaseService,
        public dialogService: DialogService,
        private formBuilder: FormBuilder,
        public dialogRef: MdDialogRef<ConfirmPayMethodPopupComponent>,
        public router: Router,
        public shareServices: SharedService,
        @Inject(MD_DIALOG_DATA) public data: any
    ) {
        this.createForm();
    }

    ngOnInit() {
        this.reportTokenId = this.utility.randomKey();
    }


    createForm() {
        this.createGroupForm = this.formBuilder.group({
            to: ['', [Validators.required]]
        });
    }

    printInvoice() {
        //call API print Invoice
        const params = {
            [AppConstants.reportParameter.InvoiceNo]: this.data.invoiceNo,
            [AppConstants.reportParameter.currency]: this.data.currencyCode,
            [AppConstants.reportParameter.pdfprintType]: 'pdf'
        };
        this.shareServices.showReport('Invoice', params);
        const result = true;
        if (result)
            this.isAssignSuccess = true;
        this.onCloseDialog();
    }

    emailInvoice() {
        const data = {
            invoiceNo: this.data.invoiceNo,
            currency: this.data.currencyCode,
            email: this.data.email
        }
        this.dialogService.openComponentDialog(EmailInvoicePopupComponent, data, { width: '400px' }).subscribe(result => {
            if (result) {
                //send success
                this.isAssignSuccess = true;
                this.onCloseDialog();
                this.router.navigateByUrl('consultation/waiting-room');
            }
        });
    }

    waitingRoom() {
        this.isAssignSuccess = true;
        this.onCloseDialog();
    }

    public onCloseDialog() {
        this.dialogRef.close(this.isAssignSuccess);
    }

}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation/cash-sale/confirm-pay-method-popup.component.ts